/**
 * Constants for Import/Export Section
 */

export const DATABASE_EXPORT_PRESETS = [
  'preset-roblox-database',
  'preset-unity-static-typed',
  'preset-roblox-static-typed',
  'preset-unity-runtime-database',
  'preset-unity-id-records',
  'preset-json-database',
  'preset-json-folder-based'
] as const;

export const FOLDER_BASED_PRESETS = [
  'preset-unity-static-typed',
  'preset-roblox-static-typed',
  'preset-unity-runtime-database',
  'preset-unity-id-records',
  'preset-json-folder-based'
] as const;

export const EXPORT_VERSION = '1.0.0';
